// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SvSJ","name":"styles_name__2CuFg","phone":"styles_phone__Z0Ici"};